import React from "react";
import defaultBackground from '../pics/backgrounds/happyTavern.png'
import ReactGA from "react-ga4";
// Make sure you have your socket instance available, e.g. import or pass as prop
import io from 'socket.io-client';
import questionMark from '../pics/icons/questionMark.png'
import Patreon from '../pics/patreon_logo.png'
import Discord from '../pics/icons/discord.png'

import {backendUrl} from '../constants.js';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log error details to Google Analytics
        ReactGA.event({
            category: "Error",
            label: error.message, // Short description of the error
            value: errorInfo.componentStack ? errorInfo.componentStack.length : 0,
        });

        // Log as pageview
        ReactGA.send({
            hitType: "pageview",
            page: "/error",
            title: "Error Page",
        });

        // Send error ping to backend via socket
        const socket = io(backendUrl)
        if (socket && socket.emit) {
            socket.emit("frontendError", {
                message: error.message,
                stack: errorInfo.componentStack,
                url: window.location.href,
                userAgent: navigator.userAgent,
                time: new Date().toISOString(),
            });
        }

        console.error("ErrorBoundary:", error, errorInfo);
        this.setState({ errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="background " style={{backgroundImage: `url(${defaultBackground})`}}>
                    <div className=" firstLoadMenuContainer" style={{justifyContent: 'flex-start'}}>
                        <div className='menuItemFirstPageContainer' style={{marginTop: '30px'}}>
                            <a className='menuHelpLink' href='https://discord.gg/26TWEMqdka' target="_blank" rel="noreferrer"> 
                                <img src={Discord} alt="Discord" className="menuIcon radius" /> 
                            </a>
                            
                            <a className='menuHelpLink' href='/help'> 
                                <img src={questionMark} alt="Help" className="menuIcon radius" />
                            </a>
                            
                            <a className='menuHelpLink' href='https://patreon.com/DmBuddy' target="_blank" rel="noreferrer"> 
                                <img src={Patreon} alt="Patreon" className="menuIcon radius" />
                            </a>
                        </div>
                        <div className="firstLoadMenu" style={{marginTop: '10px'}}>
                            <div className="homepageTopContent">
                                <h1>🦗Woah! You found a bug! 🐜</h1>
                                <p style={{margin: 0}}>I probably don't know about this bug so please reach out!</p>
                                <p style={{margin: '5px', padding: '5px', border: '2px solid grey'}}><b>nicfornicola@gmail.com</b> or <b>staygo</b> on discord or join the DmBuddy discord <b>https://discord.gg/26TWEMqdka</b></p>
                                <ul>
                                    <li>
                                        Try refreshing the page
                                    </li>
                                    <li>
                                        Try recreating your encounter
                                    </li>
                                </ul>
                                
                                <details style={{ whiteSpace: "pre-wrap" }}>
                                    <summary>Error message for nerds</summary>
                                    {this?.state?.error?.toString()}
                                    <br />
                                    {this.state.errorInfo?.componentStack}
                                </details>
                            </div>
                         </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;